import storageService from './storage'
import { parseDate, formatDate } from '../date_manipulation'

const INSTAGRAM_SEARCH_STATUS_KEY = 'searches_status:instagram'

export default {
  saveCalendarDates: (startDate, endDate) => {
    storageService.writeAndMerge(INSTAGRAM_SEARCH_STATUS_KEY, {
      startDate: formatDate({ date: startDate }),
      endDate: formatDate({ date: endDate })
    })
  },

  saveSelectedDates: (selectedDates, queryParams) => {
    storageService.writeAndMerge(INSTAGRAM_SEARCH_STATUS_KEY, { selectedDates, query: queryParams })
  },

  read: () => {
    const payload = storageService.read(INSTAGRAM_SEARCH_STATUS_KEY)

    if (payload) {
      return {
        ...payload,
        startDate: parseDate({ date: payload.startDate, outputPlugin: false }),
        endDate: parseDate({ date: payload.endDate, outputPlugin: false })
      }
    }
  },

  clear: () => storageService.clear(INSTAGRAM_SEARCH_STATUS_KEY),

  expiresIn: () => storageService.expiresIn(INSTAGRAM_SEARCH_STATUS_KEY)
}
